<template>
  <div class="icons-vue">
    <div class="icon-body">
      <div class="icon-item" v-for="temp of icons" :key="temp">
        <div @click="checkIcon(temp)">
          <p style="margin-bottom: 10px"><em :class="temp" style="font-size: 20px"></em></p>
          <p>{{ temp }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      icons: [
        'icon-eye',
        'icon-paper-clip',
        'icon-mail',
        'icon-toggle',
        'icon-layout',
        'icon-link',
        'icon-bell',
        'icon-lock',
        'icon-unlock',
        'icon-ribbon',
        'icon-image',
        'icon-signal',
        'icon-target',
        'icon-clipboard',
        'icon-clock',
        'icon-watch',
        'icon-air-play',
        'icon-camera',
        'icon-video',
        'icon-disc',
        'icon-printer',
        'icon-monitor',
        'icon-server',
        'icon-cog',
        'icon-heart',
        'icon-paragraph',
        'icon-align-justify',
        'icon-align-left',
        'icon-align-center',
        'icon-align-right',
        'icon-book',
        'icon-layers',
        'icon-stack',
        'icon-stack-2',
        'icon-paper',
        'icon-paper-stack',
        'icon-search',
        'icon-zoom-in',
        'icon-zoom-out',
        'icon-reply',
        'icon-circle-plus',
        'icon-circle-minus',
        'icon-circle-check',
        'icon-circle-cross',
        'icon-square-plus',
        'icon-square-minus',
        'icon-square-check',
        'icon-square-cross',
        'icon-microphone',
        'icon-record',
        'icon-skip-back',
        'icon-rewind',
        'icon-play',
        'icon-pause',
        'icon-stop',
        'icon-fast-forward',
        'icon-skip-forward',
        'icon-shuffle',
        'icon-repeat',
        'icon-folder',
        'icon-umbrella',
        'icon-moon',
        'icon-thermometer',
        'icon-drop',
        'icon-sun',
        'icon-cloud',
        'icon-cloud-upload',
        'icon-cloud-download',
        'icon-upload',
        'icon-download',
        'icon-location',
        'icon-location-2',
        'icon-map',
        'icon-battery',
        'icon-head',
        'icon-briefcase',
        'icon-speech-bubble',
        'icon-anchor',
        'icon-globe',
        'icon-box',
        'icon-reload',
        'icon-share',
        'icon-marquee',
        'icon-marquee-plus',
        'icon-marquee-minus',
        'icon-tag',
        'icon-power',
        'icon-command',
        'icon-alt',
        'icon-esc',
        'icon-bar-graph',
        'icon-bar-graph-2',
        'icon-pie-graph',
        'icon-star',
        'icon-arrow-left',
        'icon-arrow-right',
        'icon-arrow-up',
        'icon-arrow-down',
        'icon-volume',
        'icon-mute',
        'icon-content-right',
        'icon-content-left',
        'icon-grid',
        'icon-grid-2',
        'icon-columns',
        'icon-loader',
        'icon-bag',
        'icon-ban',
        'icon-flag',
        'icon-trash',
        'icon-expand',
        'icon-contract',
        'icon-maximize',
        'icon-minimize',
        'icon-plus',
        'icon-minus',
        'icon-check',
        'icon-cross',
        'icon-move',
        'icon-delete',
        'icon-menu',
        'icon-archive',
        'icon-inbox',
        'icon-outbox',
        'icon-qualification',
        'icon-qualification-add',
        'icon-qualification-subtract',
        'icon-help',
        'icon-open',
        'icon-ellipsis'
        // 'h-icon-info',
        // 'h-icon-warn',
        // 'h-icon-success',
        // 'h-icon-error',
        // 'h-icon-close',
        // 'h-icon-down',
        // 'h-icon-left',
        // 'h-icon-top',
        // 'h-icon-right',
        // 'h-icon-inbox',
        // 'h-icon-outbox',
        // 'h-icon-plus',
        // 'h-icon-minus',
        // 'h-icon-check',
        // 'h-icon-loading',
        // 'h-icon-spinner',
        // 'h-icon-completed',
        // 'h-icon-refresh',
        // 'h-icon-home',
        // 'h-icon-user',
        // 'h-icon-users',
        // 'h-icon-task',
        // 'h-icon-message',
        // 'h-icon-fullscreen',
        // 'h-icon-menu',
        // 'h-icon-link',
        // 'h-icon-edit',
        // 'h-icon-trash',
        // 'h-icon-complete',
        // 'h-icon-bell',
        // 'h-icon-search',
        // 'h-icon-star',
        // 'h-icon-star-on',
        // 'h-icon-setting',
        // 'h-icon-calendar',
        // 'h-icon-upload',
        // 'h-icon-github',
        // 'h-icon-location',
        // 'h-icon-help',
        // 'h-icon-help-solid',
        // 'h-icon-lock',
        // 'h-icon-angle-left',
        // 'h-icon-angle-right',
        // 'h-icon-angle-top',
        // 'h-icon-angle-down',
        // 'h-icon-close-min'
      ]
    };
  },
  methods: {
    checkIcon(value) {
      this.$emit('success', { icon: value });
    }
  }
};
</script>
<style scoped lang="less">
.icons-vue {
  height: 600px;
  overflow: hidden;
  .icon-body{
    height: 600px;
    overflow-y: scroll;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .icon-item{
      margin: 20px;
      padding: 5px;
      width: 110px;
      height: 110px;
      text-align: center;
      border: 1px #999 solid;
      border-radius: 8px;
      transition: .3s;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .icon-item:hover{
      color: #409EFF;
      border: 1px #409EFF dashed;
    }
  }
}
</style>
